<template>
    <div>
        <button type="button" @click="appendDataToModal" class="btn btn-sm btn-dark"
                data-toggle="modal" data-target="#description_modal">
            {{ $t('label.description') }}
        </button>

        <div id="description_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="shRequest_title"></div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="data_sheet" class="modal-body mb-4">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('shaparakRequests.rejection_reason') }}</th>
                            </tr>
                            </thead>
                            <tbody id="rejection_reason">
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import $ from 'jquery'
    import { i18n } from '@/plugins/i18n'

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            }
        },
        methods: {
            appendDataToModal() {
                function simpleText(data, title){
                    return '<tr><td style="width: 155px;">' + title + '</td>' +
                        '<td>' + data + '</td></tr>'
                }

                let rejection_reason = $('#rejection_reason').empty()
                let shRequest_title = $('#shRequest_title').empty()

                let ps_elements =
                    '<h4 class="modal-title float-left p-0 m-0">' +
                    i18n.t('shaparakRequests.description')+ ' ' + this.row.id + '</h4>'

                shRequest_title.append (ps_elements)

                ps_elements = ''
                if (this.row.rejection_reason) {
                    for (let $i=0; $i < this.row.rejection_reason.length; $i++)
                    ps_elements += simpleText(':' + this.row.rejection_reason[$i].fieldName ,
                        this.row.rejection_reason[$i].codeExceptionValue)
                }
                rejection_reason.append (ps_elements)
            }
        }
    })
</script>

<style>

</style>